module.exports = __webpack_public_path__ + "img/fanpage-gray.d8d9a209.svg";